export const GET_PRODUCTTYPES = "GET_PRODUCTTYPES";
